const routes = [
    {
        path: '/emissor/configuracoes',
        alias: ['/emissor/configuracoes/index'],
        component: () => import('@/domains/contador/configuracoes/views/Configurar'),
    },
   
]

export default routes
